import { organizationService } from "../_services";
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    updating: false,
    orgs: {
        list: [],
        status: status.INITIAL
    },
    categories: {
        list: [],
        status: status.INITIAL
    },
    orgTemplates: {
        list: [],
        status: status.INITIAL
    },

    selectedCategory: null,
    currentOrg: null
  },
  getters: {
    orgs: ({ orgs }) => orgs.list,
    isOrgsLoaded: ({ orgs }) => orgs.status == status.LOADED,
    categories: ({ categories }) => categories.list,
    isCategoriesLoaded: ({ categories }) => categories.status == status.LOADED,
    currentOrg: ({ currentOrg }) => currentOrg,
    isOrgLoaded: ({ currentOrg }) => currentOrg != null,
    orgTemplates: ({ orgTemplates }) => orgTemplates.list,
    isOrgTemplatesLoaded: ({ orgTemplates }) => orgTemplates.status == status.LOADED,
  },
  mutations: {
    setUpdating: (state, value) => {
      state.updating = value
    },
    setOrgs: ({ orgs }, payload) => {
      orgs.list = payload
    },
    setOrgsStatus: ({ orgs }, status) => {
      orgs.status = status
    },
    setCurrentOrg: (state, payload) => {
      state.currentOrg = payload
    },

    setCategories: ({ categories }, payload) => {
      categories.list = payload
    },
    setCategoriesStatus: ({ categories }, status) => {
      categories.status = status
    },

    selectCategory: (state, payload) => {
      state.selectedCategory = payload
    },

    setOrgTemplates: ({ orgTemplates }, payload) => {
      orgTemplates.list = payload
    },
    setOrgTemplatesStatus: ({ orgTemplates }, status) => {
      orgTemplates.status = status
    },

    addOrg: (state, org) => {
        state.orgs.list.push(org)
    },
    editOrg: (state, org) => {
      state.currentOrg = org
      if(state.orgs.list.length > 0) { 
        let curr = state.orgs.list.filter(item => item.id == org.id)[0]
        Object.assign(curr, org)
        state.categories.list.find(j => j.value === org.organizationCategory.value) ? null : state.categories.list.push(org.organizationCategory)
      }
    },
    deleteOrg: (state, orgId) => {
      let index = state.orgs.list.findIndex(item => item.id === orgId)
      state.orgs.list.splice(index, 1)
    },
    addTemplate: (state, template) => {
        state.orgTemplates.list.push(template)
    },
    editTemplate: (state, template) => {
      if(state.orgTemplates.list.length > 0) { 
        let curr = state.orgTemplates.list.filter(item => item.id == template.id)[0]
        Object.assign(curr, state.org)
      }
    },
    deleteTemplate: (state, tempId) => {
      let index = state.orgTemplates.list.findIndex(item => item.id === tempId)
      state.orgTemplates.list.splice(index, 1)
    }


  },
  actions: {
    INIT: ({ dispatch }) => {
        dispatch('LOAD_ORGS')
    },
    INIT_ITEM: ({ dispatch }, { orgId }) => {
        dispatch('LOAD_ORG', { orgId })
        dispatch('LOAD_ORG_TEMPLATES', { orgId })
    },
    LOAD_ORG: ({ state, commit }, { orgId }) => {
        if (state.CurrentOrg!=null && state.currentOrg.id != orgId) {
          commit('setCurrentOrg', null)
        }
        organizationService.organization(orgId)
        .then(data => {
          commit('setCurrentOrg', data)
        })
    },
    LOAD_ORG_TEMPLATES: ({ commit }, { orgId }) => {
        commit('setOrgTemplatesStatus', status.LOADING)
        organizationService.orgtemplates(orgId)
        .then(data => {
          commit('setOrgTemplates', data)
          commit('setOrgTemplatesStatus', status.LOADED)
        })
    },
    LOAD_ORGS: ({ commit }) => {
        commit('setOrgsStatus', status.LOADING)

        organizationService.list().then(data => {
            commit('setOrgs', data)
            commit('setOrgsStatus', status.LOADED)

            let categoryList=[] 
            data.forEach(d => {
              if(d.organizationCategory!=null){
                  categoryList.find(j => j.value === d.organizationCategory.value) ? null : categoryList.push(d.organizationCategory)
              }
            })
            commit('setCategories', categoryList)
            commit('setCategoriesStatus', status.LOADED)

        })
    },
    CREATE_ORG: ({ commit }, payload) => {
        organizationService.orgCreate( payload ).then(data => {
            commit('addOrg', data)
        })
    },
    UPDATE_ORG: ({ commit }, payload) => {
        organizationService.orgUpdate( payload ).then(data => {
            commit('editOrg', data)
        })
    },
    DELETE_ORG: ({ commit }, { orgId }) => {
        return organizationService.orgDelete( orgId ).then(data => {
            commit('deleteOrg', orgId)
            return data
        })
    },
    CREATE_TEMPLATE: ({ commit }, payload) => {
        organizationService.templateCreate( payload ).then(data => {
            commit('addTemplate', data)
        })
    },
    UPDATE_TEMPLATE: ({ commit }, payload) => {
        organizationService.templateUpdate( payload ).then(data => {
            commit('editTemplate', data)
        })
    },
    DELETE_TEMPLATE: ({ commit }, { templateId }) => {
        return organizationService.templateDelete( templateId ).then(data => {
            commit('deleteTemplate', templateId)
            return data
        })
    },
  }
}